import { render, staticRenderFns } from "./ForgotPasswordLogListView.vue?vue&type=template&id=2a56a3dc"
import script from "./ForgotPasswordLogListView.vue?vue&type=script&lang=js"
export * from "./ForgotPasswordLogListView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2a56a3dc')) {
      api.createRecord('2a56a3dc', component.options)
    } else {
      api.reload('2a56a3dc', component.options)
    }
    module.hot.accept("./ForgotPasswordLogListView.vue?vue&type=template&id=2a56a3dc", function () {
      api.rerender('2a56a3dc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/auth/ForgotPasswordLogListView.vue"
export default component.exports